export default __webpack_public_path__ + "static/media/red-swoop.d5558b93.png";